// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__fXh5K","item":"List_item__ZA_3X"};